import React, { useState } from 'react';

const TextField = ( {title, defaultValue, onChange, maxLength, tooltip, tooltipPlacement, className, id} ) => {
       const [inputValue, setInputValue] = useState(defaultValue);

       const handleInputChange = (e) => {
              setInputValue(e.target.value);
       };

       const handleKeyDown = (e) => {
              if (e.key === 'Enter') {
                     onChange(inputValue);
              }
       };


    return (
       <>
              <input
                     id={id}
                     className={"form-control"}
                     value={inputValue}
                     onBlur={(e) => onChange(e.target.value)}
                     onKeyDown={handleKeyDown}
                     maxLength={maxLength}
                     onChange={handleInputChange}
              />
              <div
                     className=""
                     id="update-zipcode-button">
              </div>
       </>
    )
}

export default TextField
